<template>
  <div class="form-group custom-form-group">
    <div class="image-uploader" @dragover="dragover" @drop="drop">
      <label v-if="displayLabel" :for="id" class="custom-form-group-label">{{ label }}</label>

      <label v-if="image" :for="id" class="image-uploader-image">
        <img :src="image"
             class="w-100">
      </label>
      <label v-else :for="id" class="image-uploader-placeholder">
        <div class="image-uploader-placeholder-icon" />
        <div class="image-uploader-placeholder-text">
          {{ $t('common.clickToUpload') }}
        </div>
      </label>

      <div v-if="helperText" v-raw="helperText" class="image-uploader-text" />

      <input :id="id"
             ref="file"
             :name="name"
             :required="required"
             type="file"
             class="d-none"
             @change="onFileChange">

      <label class="btn btn-secondary ihjoz-button image-uploader-browse" :for="id">
        {{ $t('common.browse') }}
      </label>
    </div>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";
import { humanize } from "../../helpers";

export default {
  name: "ImageUpload",

  mixins: [
    UIComponentMixin
  ],

  props: {
    value: { type: Object, default: () => {} },
    name: { type: String, default: null },
    customLabel: { type: String, default: null },
    displayLabel: { type: Boolean, default: true },
    required: { type: Boolean, default: false },
    helperText: { type: String, default: null }
  },

  data () {
    return {
      image: null
    };
  },

  computed: {
    label () {
      if (this.$useTranslations) {
        return (this.customLabel || this.$t(humanize(this.name, true)));
      } else {
        return (this.customLabel || humanize(this.name));
      }
    }
  },

  beforeMount () {
    if (this.value && this.value.url) this.image = this.value.url;
  },

  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      this.createImage(files[0]);
    },

    dragover (event) {
      event.preventDefault();
    },

    drop (event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onFileChange(event);
    },

    createImage (file) {
      // eslint-disable-next-line no-unused-vars
      var image = new Image();
      var reader = new FileReader();
      var self = this;

      reader.onload = (e) => {
        self.image = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  }
};
</script>
